export const Pathname = {
  LANDING_PAGE: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  DASHBOARD_QUOTES: "/dashboard/quotes",
  DASHBOARD_DOCUMENT: "/dashboard/drive",
  DASHBOARD_USER: "/dashboard/user",
  FORM_PARSER: "/form-parser",
  DASHBOARD_ACCOUNTING: "/dashboard/accounting",
  DASHBOARD_INVENTORY: "/dashboard/inventory",
  DASHBOARD_PROJECT: "/dashboard/project",
  DASHBOARD_PROCUREMENT: "/dashboard/procurement",
  DASHBOARD_MANUFACTURING: "/dashboard/manufacturing",
  DASHBOARD_CRM: "/dashboard/crm",
  DASHBOARD_HRMS: "/dashboard/hrms",
  DASHBOARD_OFFICE: "/dashboard/office",
  DASHBOARD_RENTAL: "/dashboard/rental",
  DASHBOARD_PURCHASE: "/dashboard/purchase",
  DASHBOARD_ONBOARDING: "/dashboard/onboarding",
  COMPONENTS: "/components",
  PAGEVIEW: "/page-view",
  "404": "/404",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  CHANGE_PASSWORD: "/change-password",
};
